import * as firebase from 'firebase';
import firestore from 'firebase/firestore'
import 'firebase/storage';



const config = {
/*apiKey: "AIzaSyDF16INNgln8xAEIYfTHR9uElwYHInfIgM",
    authDomain: "database-e91bd.firebaseapp.com",
    databaseURL: "https://database-e91bd.firebaseio.com",
    projectId: "database-e91bd",
    storageBucket: "database-e91bd.appspot.com",
    messagingSenderId: "602075998064",
    appId: "1:602075998064:web:233f862d59551c1fd111b5",
    measurementId: "G-5D9JD16P91"*/
    
    apiKey: "AIzaSyAwzngyYza1MuQK5NK4GaP4vLny2Ul8k8I",
    authDomain: "asad-894ac.firebaseapp.com",
    databaseURL: "https://asad-894ac.firebaseio.com",
    projectId: "asad-894ac",
    storageBucket: "asad-894ac.appspot.com",
    messagingSenderId: "216424420625",
    appId: "1:216424420625:web:f6221d1d5cda629dcf28b0",
    measurementId: "G-4EYNRRSS12"
 
};
firebase.initializeApp(config);


const storage = firebase.storage();

export {
    storage, firebase as default
}